// extracted by mini-css-extract-plugin
module.exports = {"link":"Markdown_link__LYi7c","paragraph":"Markdown_paragraph__I5MD2","head_markdown":"Markdown_head_markdown__Snn0Q"};